import { useEffect, useState } from "react";

/**
 * Debounces a fast-changing value (e.g. search-box input) by delayMs,
 * settling on the latest value only after it stops changing for that long.
 * Used by the History free-text search and the ⌘K command palette's remote
 * audit lookup so every keystroke doesn't fire its own network request.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
